import styled from 'styled-components';

export const Container = styled.div`
  min-width: fit-content;
`;

export const Star = styled.img`
  width: 10px;
  height: 10px;

  &:not(:last-child) {
    margin-right: 4px;
  }
`;
